import { internalLinkStyle, underlineLinkStyle } from '@bingads-webui-campaign-react/common-styles';

export const creationCommonStyle = ({ palette = {} }, { isCreationPage = true } = {}) => (Object.assign({

  '& .steps-wizard__description': {
    marginTop: 8,
    marginBottom: 0,
    marginLeft: 32,
    color: palette.neutralSecondary,
  },

  '& .advanced-campaign-creation__wrapper': {
    marginLeft: 32,
    marginRight: 32,
    paddingBottom: 12,
  },

  '& .action-container': {
    marginLeft: 32,
  },

  '& .step-content-container .content-container, .step-content-container > .action-container': {
    minWidth: 1380,
  },

  '& .row': {
    margin: 0,
  },

  '& .helpbutton': {
    display: 'inline-block',
    marginLeft: 5,
  },

  '& label': {
    display: 'inline-block',
  },

  '& span': {
    verticalAlign: 'middle',
  },

  '& .display-inline-block': {
    display: 'inline-block !important',
  },

  '& .help-block, .remaining-chars-hint-container': {
    textAlign: 'right',
    fontSize: 14,
    margin: 0,
    color: palette.neutralPrimary,
    lineHeight: '24px',
  },

  '& .help-block.error': {
    textAlign: 'left',
  },

  '& ol, ul': {
    listStyle: 'none',
    paddingLeft: 0,
  },

  '& .validation-error': {
    border: '1px solid #A80000 !important',
    backgroundColor: palette.white,
    margin: 0,
  },

  '& .error': {
    color: '#A80000',
  },

  '& div.error': {
    fontSize: 12,
  },

  '& input.error, select.error, textarea.error, input.campaign-error-row, select.campaign-error-row, textarea.campaign-error-row': {
    border: '1px solid #A80000 !important',
  },

  '& .form-group': {
    padding: 0,
    marginBottom: 0,
  },

  '& .form-control': {
    height: 32,
    border: `1px solid ${palette.neutralSecondary}`,
    boxSizing: 'border-box',
    borderRadius: 2,
  },

  '& .form-control:focus': {
    border: `1px solid ${palette.neutralSecondary}`,
  },

  '& .form-control-static': {
    paddingTop: 0,
    paddingBottom: 0,
    margin: 0,
    height: 'auto',
    color: palette.neutralSecondary,

    '&.copy-settings': {
      marginTop: 4,
    },
  },

  '& .control-label, .form-label-container': {
    textAlign: 'left',
    width: 'auto',
    float: 'none',
    marginTop: 33,
    fontSize: 14,
    color: palette.neutralPrimary,
    paddingTop: 0,
    paddingBottom: 0,
    display: 'block',
  },

  '& .form-label-container': {
    '&>label>span': {
      padding: '5px 0px',
      display: 'inline-block',
    },
  },

  '& .control-label .col-sm-4': {
    width: 'auto',
  },

  '& .displayNone': {
    display: 'none',
  },

  '& select': {
    appearance: 'none',
    '-webkit-appearance': 'none',
  },

  '& textarea': {
    resize: 'none',
  },

  '& .input-group-addon': {
    backgroundColor: palette.white,
    border: 0,
  },

  '& .bidding-strategy__container': {
    '& .alert-image': {
      paddingTop: 5,
    },
    '& .alert.alert-info': {
      margin: '8px 0',
      lineHeight: 'unset',
    },
  },

  '& .alert-info.form-group': {
    '& .alert-info-inline': {
      ...internalLinkStyle({ palette, elementLocator: '> a', isGreyBackground: true }),
      '& > a:focus': {
        border: 0,
      },
    },
  },

  '& .cashback-settings .alert.alert-info': {
    marginTop: 15,
    marginRight: 24,
    marginLeft: 'unset',
    lineHeight: 'unset',
  },

  '& .cashback-settings .alert-div': {
    width: '50%',
  },

  ...underlineLinkStyle({ palette, elementLocator: 'a.HelpTopic' }),
  '& a.HelpTopic:focus': {
    border: 0,
  },
}, isCreationPage ? {
  '& .checkbox > label + .helpbutton, .radio > label + .helpbutton': {
    marginLeft: '-6px',
  },
} : {}));

